module.exports = __webpack_public_path__ + "media/images/new_home/edit-icon-white-988f9cd90d4207f71d7e7a707a08da65.png";